// Return the current environment based on current hostname and baseUrl config
// Strip the protocol when comparing so it doesn't matter if someone is at
// http or https or if www is in the URL. Just matching on the domain and port.
function getEnvironment(hostname, baseUrls) {
  var currentEnv = null;

  Object.keys(baseUrls).map(function(env) {
    var regexString = '^' + stripProtocol(baseUrls[env].app) + '$';
    var regexp = new RegExp(regexString, 'i');
    const match = regexp.test(stripProtocol(hostname));
    if (match) currentEnv = env;
  });

  if (!currentEnv) {
    throw new Error(
      'Missing environment configuration for this base URL in the fusion-http configuration: ' +
        hostname +
        ". Make sure you've specified a baseUrl that precisely matches " +
        hostname +
        '. For example, omit the trailing slash and specify the port number if relevant.'
    );
  }

  return currentEnv;
}

// Return url without the protocol. (http(s)://, http://www.)
function stripProtocol(url) {
  // regex source:
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
}

// Return the corresponding API base URL for the specified environment
function getApiBaseUrl(env, baseUrls) {
  var url = baseUrls[env].api;

  if (!url) {
    throw new Error(
      'Missing environment configuration for this URL: ' + hostname
    );
  }

  return url;
}

module.exports = {
  getEnvironment: getEnvironment,
  getApiBaseUrl: getApiBaseUrl,
  stripProtocol: stripProtocol
};



//////////////////
// WEBPACK FOOTER
// ../fusion-http/utils.js
// module id = 256
// module chunks = 2